import { defineStore } from 'pinia';
import {reactive, ref} from "vue";
import {useOrderDataStore} from "@/stores/orderDataStore";


export const UseCourierStore = defineStore('courierStore', {
    state: () => reactive({
        selectedCourier: ref(null), // This will hold the user's selection
        selectedCourierDesc: ref(null),
        selectedCourierLogo: ref(null),
        selectedCourierReturnCost: ref(null),
        selectedAddress: ref(""),
        selectedAddressCC: ref(""),
        addressName: null,
        showInfo: false,
        editInfo: false,
        saveEdit: false,
        deleteAddress: ref(false),
        formData_backup: ref({
            id: null,
            name: null,
            phone: null,
            email: null,
            address: null,
            city: null,
            zip: null,
            comments: null,
            country: null
        }),
        formData: ref({
            id: null,
            name: null,
            phone: null,
            email: null,
            address: null,
            city: null,
            zip: null,
            comments: null,
            country: null
        }),
        rmaDeliveryAddress: ref({
            id: null,
            name: null,
            phone: null,
            email: null,
            address: null,
            city: null,
            zip: null,
            country: null
        }),
    }),


    actions: {

        setDefaultRmaDeliveryAddress() {
            const orderDataStore = useOrderDataStore();
            this.rmaDeliveryAddress = {
                id: orderDataStore.deliveryAddress.id,
                name: orderDataStore.deliveryAddress.name,
                phone: orderDataStore.deliveryAddress.phone,
                email: orderDataStore.deliveryAddress.email,
                address: orderDataStore.deliveryAddress.address,
                city: orderDataStore.deliveryAddress.city,
                zip: orderDataStore.deliveryAddress.zip,
                country: orderDataStore.deliveryAddress.country
            };
        },

        setSelectedCourierDesc(description) {
            this.selectedCourierDesc = description;
        },
        setSelectedCourierLogo(logo) {
            this.selectedCourierLogo = logo;
        },
        setSelectedCourierReturnCost(cost) {
            this.selectedCourierReturnCost = cost;
        },
        
        setSelectedAddress(address) {
            this.selectedAddress = address;
        },
        

        $reset() {
            this.selectedCourier = null;
            this.selectedCourierDesc = null;
            this.selectedCourierLogo = null;
            this.selectedCourierReturnCost = null;
            this.selectedAddress = "";
            this.addressName = null;
            this.showInfo = false;
            this.formData_backup = {
                id: null,
                name: null,
                phone: null,
                email: null,
                address: null,
                city: null,
                zip: null,
                comments: null,
                country: null
            };
        }
    },
    persist: true
});


